import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { path: "/", label: "首页" },
    { path: "/category/xuanyi", label: "悬疑" },
    { path: "/category/dongzuo", label: "动作" },
    { path: "/category/aiqing", label: "爱情" },
    { path: "/category/kehuan", label: "科幻" },
    { path: "/category/xiju", label: "喜剧" },
    { path: "/category/kongbu", label: "恐怖" },
    { path: "/about", label: "关于我们" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading font-bold text-sm">
            桃
          </span>
          <span className={`font-heading font-bold text-lg transition-colors duration-300 ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}>
            红桃影视大全
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path ||
              (link.path !== "/" && location.pathname.startsWith(link.path));
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : scrolled
                    ? "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
                    : "text-background-50/90 hover:text-background-50 hover:bg-background-50/15"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="切换菜单"
        >
          <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap transition-all ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
}